<nav class="lc-navigation-bar pb-3" mat-tab-nav-bar [tabPanel]="tabPanel">
  <!-- Display each tab item as a link-->
  @for (tab of tabs; track tab) {
    @if (tab.isVisible$ | async) {
      <a mat-tab-link [active]="tab.id == activeId" [id]="tab.id" [routerLink]="tab.path">{{tab.label}}</a>
    }
  }
</nav>

<mat-divider class="mb-md" />

<!-- The router outlet displays the child component -->
<mat-tab-nav-panel #tabPanel>
  <router-outlet />
</mat-tab-nav-panel>
